import clamp from 'lodash/clamp'

export function validateVolume(ratio: number) {
  return clamp(ratio, 0, 1)
}
